/** @format */

export function getUser(id = null) {
  return id ? id == this.state.project.userId : this.state.project.userId;
}

export function isUser(id) {
  return this.state.project.userId == id || this.props.user.id;
}
